import * as R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from './check_box';

function InvertibleInput(props) {
    const header = props.isInverted ? props.invertedHeader : props.header;
    const help = props.isInverted ? props.invertedHelp : props.help;
    const childComponent = React.cloneElement(React.Children.only(props.children), {header, help});
    return (
        <div className="invertible">
            <div>
                <Checkbox
                    label="Invert"
                    name={props.name}
                    help=""
                    checked={props.isInverted}
                    onChange={R.partial(props.onChange, [props.name])}
                />
            </div>
            <div>{childComponent}</div>
        </div>
    );
}

InvertibleInput.propTypes = {
    isInverted: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    invertedHeader: PropTypes.string.isRequired,
    help: PropTypes.string.isRequired,
    invertedHelp: PropTypes.string.isRequired
};

export default InvertibleInput;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/invertible_input.js